import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { LiveMessage } from 'react-aria-live';
import reactT from './../../components/reactT';

function FallbackSearchResults() {
  const [fallbackHtml, setFallbackHtml] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Do not load fallback view if current path is /search
    if (window.location.pathname === '/search') {
      setLoading(false);
      return;
    }

    // get current page path if isset drupalSettings.fallback_urls[window.location.pathname] then fetch else fetch first url
    /*global drupalSettings:true*/
    let fallback_url = '';
    if (typeof drupalSettings !== 'undefined' && drupalSettings.fallback_urls[window.location.pathname]) {
      fallback_url = drupalSettings.fallback_urls[window.location.pathname];
    }
    else {
      fallback_url = Object.values(drupalSettings.fallback_urls)[0];
    }

    // add query string page and get it from current url
    const params = new URLSearchParams(window.location.search);
    const page = params.get('page');
    if (page) {
      fallback_url += `?page=${page}`;
    }
    fetch(fallback_url)
      .then(response => response.json())
      .then(data => {
        console.log('Fallback search data:', data);
        if (data.html) {
        setFallbackHtml(data.html);
      }
      setLoading(false);
    })
    .catch(error => {
      console.error('Error fetching fallback search:', error);
      setLoading(false);
    });
  }, []);

  // Run JavaScript when component mounts to modify layout classes
  useEffect(() => {
    // Do not load fallback view if current path is /search
    if (window.location.pathname === '/search') {
      setLoading(false);
      return;
    }

    const modifyElements = () => {
      const exposedForms = document.querySelectorAll('.views-exposed-form');
      const sidebarFacets = document.querySelectorAll('.sidebar-facets');
      const unhcrSearch = document.querySelectorAll('.unhcr-search');
      
      exposedForms.forEach(form => {
        form.style.display = 'none';
      });
      
      sidebarFacets.forEach(sidebar => {
        sidebar.classList.remove('d-md-block');
      });
      
      unhcrSearch.forEach(search => {
        search.classList.remove('col-lg-9', 'col-md-6');
      });
    };

    modifyElements();

    // Clean up when component unmounts - restore the elements
    return () => {
      const exposedForms = document.querySelectorAll('.views-exposed-form');
      const sidebarFacets = document.querySelectorAll('.sidebar-facets');
      const unhcrSearch = document.querySelectorAll('.unhcr-search');
      
      exposedForms.forEach(form => {
        form.style.display = '';
      });
      
      sidebarFacets.forEach(sidebar => {
        sidebar.classList.add('d-md-block');
      });
      
      unhcrSearch.forEach(search => {
        search.classList.add('col-lg-9', 'col-md-6');
      });
    };
  }, []);

  if (loading) {
    return <div className="fallback-search-results col-12">{reactT('Loading fallback results...')}</div>;
  }

  return (
    <div 
      className="fallback-search-results col-12"
      dangerouslySetInnerHTML={{ __html: fallbackHtml }}
    />
  );
}

function searchResultsStat(pending,currentPage, numFound, rows, pageAmt, noResultsText, termValue, solrUnavailable) {
  // Set visible and a11y message based on query results.
  let message = '';
  let options = [];
  options['@count'] = numFound;
  if (numFound > rows && !pending) { // Many pages
    message = 'Showing @count results for';
  } else if (numFound <= rows && numFound > 1) { // Single page
    message = 'Showing @count results for';
  } else if (numFound === 1) { // Single item
    message = reactT('Showing @count result for');
  } else if (numFound === 0 && !pending) { // No results
    message = noResultsText || 'Sorry, your search yielded no results.';
  } else if (pending){
    message = reactT('Waiting for results');
  }

  if (solrUnavailable) { // Solr Unavailable
    message = reactT('The search feature is currently unavailable due to technical maintenance. Please try again later. Thank you for your understanding.');

    return (
      <React.Fragment>
        <LiveMessage message={reactT(message, options)} aria-live="polite" />
        <div aria-label="Status message" role="status" class="alert show col-12 alert-warning solr-unavailable">{reactT(message, options)}</div>
        <FallbackSearchResults />
      </React.Fragment>
    );
  }
  // Don't announce total results when wildcard query sent on term clear.
  return (
    <React.Fragment>
      <LiveMessage message={reactT(message, options)} aria-live="polite" />
      <p id="stat" tabIndex="-1" className="view-header">{reactT(message, options)}</p>
    </React.Fragment>
  );
}

class FederatedCountLabel extends React.Component {
  render() {
    const {
      pending,
      numFound,
      start,
      rows,
      noResultsText,
      termValue,
    } = this.props;

    var solrUnavailable = false;
    var total = numFound;
    if (numFound === 'solrUnavailable') {
      solrUnavailable = true;
      total = 0;
    }

    const currentPage = start / rows;
    const pageAmt = Math.ceil(total / rows);
    return (
      <React.Fragment>
        {searchResultsStat(pending,currentPage, total, rows, pageAmt, noResultsText, termValue, solrUnavailable)}
      </React.Fragment>
    );
  }
}

FederatedCountLabel.propTypes = {
  numFound: PropTypes.number.isRequired,
  start: PropTypes.number.isRequired,
  rows: PropTypes.number,
  solrUnavailable: PropTypes.bool,
};

FederatedCountLabel.defaultProps = {
  start: 0,
};

export default FederatedCountLabel;
